import { style } from '@vanilla-extract/css';

export const connectionStatus = style({
  textTransform: 'capitalize',
});
